export const setTVLoginPage = (status) => {
    return {
        type: 'Set_TV_Login_Page',
        payload: status
    }
}

export const setChannelData = (data) => {
    return{
        type: 'Set_Channel_Data',
        payload: data
    }
}